// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.turing-ui-v2-start-mcq-modal-container {
  display: flex;
}
.turing-ui-v2-start-mcq-modal-container > * {
  flex: 1;
  width: 50%;
}

.turing-ui-v2-start-mcq-modal-title {
  display: flex;
  gap: 6px;
  align-items: center;
}

.turing-ui-v2-start-mcq-modal-container > .turing-ui-v2-start-mcq-modal-left,
.turing-ui-v2-start-mcq-modal-left .ant-card.icon-card,
.turing-ui-v2-start-mcq-modal-left .ant-card-body {
  display: flex;
  align-items: center;
  justify-content: center;
}

.turing-ui-v2-start-mcq-modal-left .ant-card-body > img {
  max-width: 85%;
}
.turing-ui-v2-start-mcq-modal-right {
  min-height: 400px;
}
.turing-ui-v2-start-mcq-modal-right .details-card {
  display: flex;
}
.turing-ui-v2-start-mcq-modal-right .ant-card-body {
  display: flex;
  flex-direction: column;
  max-width: 100%;
}

.turing-ui-v2-start-mcq-modal-right .challenge-description {
  flex: 1;
  margin: 20px 0;
}

.turing-ui-v2-start-mcq-modal-right .completed {
  display: flex;
  align-items: center;
}
.turing-ui-v2-start-mcq-modal-right .mcq-modal {
  background: #fafafa 0% 0% no-repeat padding-box;
  border-radius: 4px 0 0 4px;
  opacity: 1;
}

.turing-ui-v2-start-mcq-modal-right .description {
  white-space: normal;
  min-height: 129px;
  left: 16px;
  padding-right: 40px;
}

.turing-ui-v2-start-mcq-modal-right .modal-row-flex {
  padding: 0 !important;
  flex-flow: row !important;
}

.turing-ui-v2-start-mcq-modal-right .icon-card {
  background: #fafafa 0% 0% no-repeat padding-box;
  border-radius: 4px 0 0 4px;
  opacity: 1;
  height: 100%;
  width: 100%;
  position: relative;
}

.turing-ui-v2-start-mcq-modal-right .details-card {
  height: 100%;
  width: 100%;
}

.turing-ui-v2-start-mcq-modal-right .timer {
  height: 56px;
  left: 16px;
  padding-right: 40px;
}

.turing-ui-v2-start-mcq-modal-right .details-title {
  height: 69px;
  left: 16px;
  padding-right: 40px;
}

.turing-ui-v2-start-mcq-modal-right .start-button {
  height: 52px;
  left: 0 !important;
  padding: 10px 0;
}

.turing-ui-v2-start-mcq-modal-right .timer-text {
  text-align: left;
  font: Medium 14px/20px;
  font-weight: 500;
  letter-spacing: 0;
  color: #66cc80;
  opacity: 1;
  height: "27px";
}

.turing-ui-v2-start-mcq-modal-right .time-left {
  text-align: left;
  font: Medium 14px/20px;
  font-weight: 500;
  letter-spacing: 0;
  color: #ffae3b;
  opacity: 1;
  height: "27px";
}

.turing-ui-v2-take-next-mcq-modal {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.turing-ui-v2-take-next-mcq-modal > p {
  max-width: 400px;
  text-align: center;
  margin: 16px;
}

.turing-ui-v2-take-next-mcq-modal > b {
  text-align: center;
  margin-top: 32px;
}

.turing-ui-v2-take-next-mcq-modal > button {
  margin-top: 32px;
}

.turing-ui-v2-take-next-mcq-modal-certified-bg {
  position: absolute;
  z-index: 0;
  top: -5px;
}

.turing-ui-v2-take-next-mcq-modal-certified-bg + img {
  z-index: 1;
  height: 60px;
  width: 60px;
  border-radius: 50%;
}

.turing-ui-v2-take-next-mcq-modal-certified > b {
  margin-top: 50px !important;
}

.timeEstimate {
  display: flex;
  align-items: center;
  grid-gap: 5px;
  gap: 2px;
  padding: 6px 12px 6px 8px;
  /* padding: 6px 10px; */
  white-space: nowrap;
  border-radius: 6px;
  background-color: #f8f8f8;
  color: #444;
}

.timeEstimate svg path {
  fill: #444;
}
`, "",{"version":3,"sources":["webpack://./src/v3/legacy_components/UI_V2_Components/tests/Modals/StartMCQ.modal.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;AACA;EACE,OAAO;EACP,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,+CAA+C;EAC/C,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,+CAA+C;EAC/C,0BAA0B;EAC1B,UAAU;EACV,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,UAAU;AACZ","sourcesContent":[".turing-ui-v2-start-mcq-modal-container {\n  display: flex;\n}\n.turing-ui-v2-start-mcq-modal-container > * {\n  flex: 1;\n  width: 50%;\n}\n\n.turing-ui-v2-start-mcq-modal-title {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n}\n\n.turing-ui-v2-start-mcq-modal-container > .turing-ui-v2-start-mcq-modal-left,\n.turing-ui-v2-start-mcq-modal-left .ant-card.icon-card,\n.turing-ui-v2-start-mcq-modal-left .ant-card-body {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.turing-ui-v2-start-mcq-modal-left .ant-card-body > img {\n  max-width: 85%;\n}\n.turing-ui-v2-start-mcq-modal-right {\n  min-height: 400px;\n}\n.turing-ui-v2-start-mcq-modal-right .details-card {\n  display: flex;\n}\n.turing-ui-v2-start-mcq-modal-right .ant-card-body {\n  display: flex;\n  flex-direction: column;\n  max-width: 100%;\n}\n\n.turing-ui-v2-start-mcq-modal-right .challenge-description {\n  flex: 1;\n  margin: 20px 0;\n}\n\n.turing-ui-v2-start-mcq-modal-right .completed {\n  display: flex;\n  align-items: center;\n}\n.turing-ui-v2-start-mcq-modal-right .mcq-modal {\n  background: #fafafa 0% 0% no-repeat padding-box;\n  border-radius: 4px 0 0 4px;\n  opacity: 1;\n}\n\n.turing-ui-v2-start-mcq-modal-right .description {\n  white-space: normal;\n  min-height: 129px;\n  left: 16px;\n  padding-right: 40px;\n}\n\n.turing-ui-v2-start-mcq-modal-right .modal-row-flex {\n  padding: 0 !important;\n  flex-flow: row !important;\n}\n\n.turing-ui-v2-start-mcq-modal-right .icon-card {\n  background: #fafafa 0% 0% no-repeat padding-box;\n  border-radius: 4px 0 0 4px;\n  opacity: 1;\n  height: 100%;\n  width: 100%;\n  position: relative;\n}\n\n.turing-ui-v2-start-mcq-modal-right .details-card {\n  height: 100%;\n  width: 100%;\n}\n\n.turing-ui-v2-start-mcq-modal-right .timer {\n  height: 56px;\n  left: 16px;\n  padding-right: 40px;\n}\n\n.turing-ui-v2-start-mcq-modal-right .details-title {\n  height: 69px;\n  left: 16px;\n  padding-right: 40px;\n}\n\n.turing-ui-v2-start-mcq-modal-right .start-button {\n  height: 52px;\n  left: 0 !important;\n  padding: 10px 0;\n}\n\n.turing-ui-v2-start-mcq-modal-right .timer-text {\n  text-align: left;\n  font: Medium 14px/20px;\n  font-weight: 500;\n  letter-spacing: 0;\n  color: #66cc80;\n  opacity: 1;\n  height: \"27px\";\n}\n\n.turing-ui-v2-start-mcq-modal-right .time-left {\n  text-align: left;\n  font: Medium 14px/20px;\n  font-weight: 500;\n  letter-spacing: 0;\n  color: #ffae3b;\n  opacity: 1;\n  height: \"27px\";\n}\n\n.turing-ui-v2-take-next-mcq-modal {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n}\n\n.turing-ui-v2-take-next-mcq-modal > p {\n  max-width: 400px;\n  text-align: center;\n  margin: 16px;\n}\n\n.turing-ui-v2-take-next-mcq-modal > b {\n  text-align: center;\n  margin-top: 32px;\n}\n\n.turing-ui-v2-take-next-mcq-modal > button {\n  margin-top: 32px;\n}\n\n.turing-ui-v2-take-next-mcq-modal-certified-bg {\n  position: absolute;\n  z-index: 0;\n  top: -5px;\n}\n\n.turing-ui-v2-take-next-mcq-modal-certified-bg + img {\n  z-index: 1;\n  height: 60px;\n  width: 60px;\n  border-radius: 50%;\n}\n\n.turing-ui-v2-take-next-mcq-modal-certified > b {\n  margin-top: 50px !important;\n}\n\n.timeEstimate {\n  display: flex;\n  align-items: center;\n  grid-gap: 5px;\n  gap: 2px;\n  padding: 6px 12px 6px 8px;\n  /* padding: 6px 10px; */\n  white-space: nowrap;\n  border-radius: 6px;\n  background-color: #f8f8f8;\n  color: #444;\n}\n\n.timeEstimate svg path {\n  fill: #444;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
